// extracted by mini-css-extract-plugin
export var header = "styles-module--header--a+NL6";
export var fixedHeader = "styles-module--fixedHeader--ijdBk";
export var container = "styles-module--container--vzrwR";
export var logoContainer = "styles-module--logoContainer--lx4tl";
export var nav = "styles-module--nav--EHi7K";
export var button = "styles-module--button--YTzv7";